import { render, staticRenderFns } from "./lancarRelatorioBNCCSemestralPage.vue?vue&type=template&id=e0a486f8"
import script from "./lancarRelatorioBNCCSemestralPage.vue?vue&type=script&lang=js"
export * from "./lancarRelatorioBNCCSemestralPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports